import { render } from "./AppointmentTreatmentSelector.vue?vue&type=template&id=2fdf671c&scoped=true&ts=true"
import script from "./AppointmentTreatmentSelector.vue?vue&type=script&lang=ts"
export * from "./AppointmentTreatmentSelector.vue?vue&type=script&lang=ts"

import "./AppointmentTreatmentSelector.vue?vue&type=style&index=0&id=2fdf671c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdf671c"]])

export default __exports__